var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundInProgress(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920.177,
    height: 1277,
    viewBox: "0 0 1920.177 1277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fundal_Portofolio",
    "data-name": "Fundal Portofolio",
    transform: "translate(0.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fundal_Portofolio-2",
    "data-name": "Fundal Portofolio"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 1920,
    height: 1277,
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M-3855.491,870.113l16.7,24.386Zm-194.825-78.23a8.5,8.5,0,0,1-2.5-11.757,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.759,8.491,8.491,0,0,1-7.135,3.871A8.462,8.462,0,0,1-4050.316,791.883Zm334.183-50.068a8.5,8.5,0,0,1-2.5-11.758,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.758,8.491,8.491,0,0,1-7.136,3.872A8.461,8.461,0,0,1-3716.132,741.815Zm-255.92-15.363-26.578,4.2Zm107.124-18.071a8.5,8.5,0,0,1-2.5-11.758,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.758,8.491,8.491,0,0,1-7.136,3.872A8.46,8.46,0,0,1-3864.928,708.381Zm-341.127-65.928-17.014,15.183Zm283.963,6.149a4,4,0,0,1-1.176-5.533,4,4,0,0,1,5.532-1.177,4,4,0,0,1,1.176,5.533,4,4,0,0,1-3.359,1.823A3.976,3.976,0,0,1-3922.093,648.6Zm-397.528-50.687a4,4,0,0,1-1.177-5.533,4,4,0,0,1,5.535-1.176,4,4,0,0,1,1.175,5.533,4,4,0,0,1-3.358,1.821A3.98,3.98,0,0,1-4319.62,597.916Zm547.756-50.282,7.64,24.04Zm107.428,7.166a6,6,0,0,1-1.764-8.3,6,6,0,0,1,8.3-1.765,6,6,0,0,1,1.764,8.3,6,6,0,0,1-5.038,2.733A5.968,5.968,0,0,1-3664.436,554.8Zm172.762-64.447-29.4.776Zm-897.906-24.315,3.322,22.428Z",
    transform: "translate(4911 -321.08)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "matrix(0.99, -0.139, 0.139, 0.99, -41.41, 27.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(35 360.704)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(402.66 454.187)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 7.868,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 6.868,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(188.359 436.599)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(206.107 386.675)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(52.983 189.553)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(235.891 517.127)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 20.231,
    y2: 22.479,
    transform: "translate(125.476 373.884)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 19.107,
    y2: 16.859,
    transform: "translate(116.485 48.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M1.407,0-11.356,30.672",
    transform: "translate(80.236 474.98)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0,7.372,27.235",
    transform: "translate(532.507 558.216)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 24.726,
    y2: 6.744,
    transform: "translate(56.917 218.66)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 17.983,
    y2: 21.917,
    transform: "translate(341.699 436.436)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M-3371.618,746.123l-20.608,20.98Zm54.153-138.355a6,6,0,0,1,4.745-7.036,6,6,0,0,1,7.034,4.746,6,6,0,0,1-4.745,7.034,6.033,6.033,0,0,1-1.151.111A6,6,0,0,1-3317.465,607.768Zm64.806-88.492,22.195,11.985Zm-159.507-79.016a8.5,8.5,0,0,1,6.722-9.966,8.5,8.5,0,0,1,9.965,6.723,8.5,8.5,0,0,1-6.721,9.966,8.552,8.552,0,0,1-1.63.157A8.5,8.5,0,0,1-3412.166,440.26Zm130.259-79.312a8.5,8.5,0,0,1,6.723-9.966,8.5,8.5,0,0,1,9.965,6.721,8.5,8.5,0,0,1-6.721,9.966,8.548,8.548,0,0,1-1.632.158A8.5,8.5,0,0,1-3281.907,360.949Zm86.206-1.985a4,4,0,0,1,3.163-4.69,4,4,0,0,1,4.689,3.165,4,4,0,0,1-3.163,4.689,4.023,4.023,0,0,1-.767.074A4,4,0,0,1-3195.7,358.963Zm1.22-116.881-16.2,21.485Zm-228.8-6.825,28.956,5.94Z",
    transform: "translate(4911 -187.719)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804",
    transform: "translate(0 562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2-2",
    "data-name": "Intersection 2",
    d: "M-3855.491,870.113l16.7,24.386Zm-194.825-78.23a8.5,8.5,0,0,1-2.5-11.757,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.759,8.491,8.491,0,0,1-7.135,3.871A8.462,8.462,0,0,1-4050.316,791.883Zm334.183-50.068a8.5,8.5,0,0,1-2.5-11.758,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.758,8.491,8.491,0,0,1-7.136,3.872A8.461,8.461,0,0,1-3716.132,741.815Zm-255.92-15.363-26.578,4.2Zm107.124-18.071a8.5,8.5,0,0,1-2.5-11.758,8.5,8.5,0,0,1,11.758-2.5,8.5,8.5,0,0,1,2.5,11.758,8.491,8.491,0,0,1-7.136,3.872A8.46,8.46,0,0,1-3864.928,708.381Zm-341.127-65.928-17.014,15.183Zm283.963,6.149a4,4,0,0,1-1.176-5.533,4,4,0,0,1,5.532-1.177,4,4,0,0,1,1.176,5.533,4,4,0,0,1-3.359,1.823A3.976,3.976,0,0,1-3922.093,648.6Zm-397.528-50.687a4,4,0,0,1-1.177-5.533,4,4,0,0,1,5.535-1.176,4,4,0,0,1,1.175,5.533,4,4,0,0,1-3.358,1.821A3.98,3.98,0,0,1-4319.62,597.916Zm547.756-50.282,7.64,24.04Zm107.428,7.166a6,6,0,0,1-1.764-8.3,6,6,0,0,1,8.3-1.765,6,6,0,0,1,1.764,8.3,6,6,0,0,1-5.038,2.733A5.968,5.968,0,0,1-3664.436,554.8Zm172.762-64.447-29.4.776Zm-897.906-24.315,3.322,22.428Z",
    transform: "translate(4911 -321.08)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines-2",
    "data-name": "Circles and lines",
    transform: "matrix(0.99, -0.139, 0.139, 0.99, -41.41, 27.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57-2",
    "data-name": "Ellipse 57",
    transform: "translate(35 360.704)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(402.66 454.187)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 7.868,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 6.868,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    transform: "translate(188.359 436.599)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(206.107 386.675)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-2",
    "data-name": "Ellipse 61",
    transform: "translate(52.983 189.553)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    transform: "translate(235.891 517.127)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82-2",
    "data-name": "Line 82",
    x2: 20.231,
    y2: 22.479,
    transform: "translate(125.476 373.884)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85-2",
    "data-name": "Line 85",
    x1: 19.107,
    y2: 16.859,
    transform: "translate(116.485 48.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125-2",
    "data-name": "Path 1125",
    d: "M1.407,0-11.356,30.672",
    transform: "translate(80.236 474.98)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126-2",
    "data-name": "Path 1126",
    d: "M-11.356,0,7.372,27.235",
    transform: "translate(532.507 558.216)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    x2: 24.726,
    y2: 6.744,
    transform: "translate(56.917 218.66)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86-2",
    "data-name": "Line 86",
    x1: 17.983,
    y2: 21.917,
    transform: "translate(341.699 436.436)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1-2",
    "data-name": "Intersection 1",
    d: "M-3371.618,746.123l-20.608,20.98Zm54.153-138.355a6,6,0,0,1,4.745-7.036,6,6,0,0,1,7.034,4.746,6,6,0,0,1-4.745,7.034,6.033,6.033,0,0,1-1.151.111A6,6,0,0,1-3317.465,607.768Zm64.806-88.492,22.195,11.985Zm-159.507-79.016a8.5,8.5,0,0,1,6.722-9.966,8.5,8.5,0,0,1,9.965,6.723,8.5,8.5,0,0,1-6.721,9.966,8.552,8.552,0,0,1-1.63.157A8.5,8.5,0,0,1-3412.166,440.26Zm130.259-79.312a8.5,8.5,0,0,1,6.723-9.966,8.5,8.5,0,0,1,9.965,6.721,8.5,8.5,0,0,1-6.721,9.966,8.548,8.548,0,0,1-1.632.158A8.5,8.5,0,0,1-3281.907,360.949Zm86.206-1.985a4,4,0,0,1,3.163-4.69,4,4,0,0,1,4.689,3.165,4,4,0,0,1-3.163,4.689,4.023,4.023,0,0,1-.767.074A4,4,0,0,1-3195.7,358.963Zm1.22-116.881-16.2,21.485Zm-228.8-6.825,28.956,5.94Z",
    transform: "translate(4911 -187.719)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Linie",
    d: "M1645.263,2053.569s499.117-35.49,624.206-139.561,262.771-240.127,406.927-231.181,191.584,93.41,174.348,231.181-123.981,231.228-259.418,308.3-468.669,19.343-468.669,19.343-208.69-28.778-239.04,67.7-20.03,200.466,125.171,298.874,511.015-34.515,511.015-34.515,232.549-127.411,470.2-173.036,412.794,12.868,573.664,120.222",
    transform: "translate(-1645.262 -1676.955)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeDasharray: "20 15"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundInProgress);
export default __webpack_public_path__ + "static/media/backgroundInProgress.aa666d6ed8632b7d12bee9a51e37763b.svg";
export { ForwardRef as ReactComponent };